"use client";
import { useRouter, Link } from "@/i18n/routing";
import { useLocale, useTranslations } from "next-intl";
import Image from "next/image";
export default function Header() {
  const t = useTranslations();
  const locale = useLocale();
  const router = useRouter();

  return (
    <header className="bg-opacity-30 bg-cover bg-right-top md:h-48 md:hidden [@media(min-aspect-ratio:1600/600)]:h-8">
      <div className="relative mx-auto h-full max-w-screen-md">
        <Link
          href={"/"}
          locale={locale}
          className="absolute left-0 m-2 cursor-pointer p-2 text-2xl transition-transform hover:scale-125 [@media(min-aspect-ratio:1600/600)]:static [@media(min-aspect-ratio:1600/600)]:my-0"
        >
          <span className="icon-icon6" />
        </Link>
        <div className="flex size-full flex-col items-center justify-center py-5 [@media(min-aspect-ratio:1600/600)]:hidden">
          <h1>{t("welcome-to")}</h1>
          <Image src="/maha_logo1.webp" alt="maha6 logo" width={200} height={200} />
        </div>
      </div>
    </header>
  );
}
